import UsersMobileRow from './UsersMobileRow';

export default UsersMobileRow;
